import { api } from '../hooks/useApi';
import type { ApiEnvelope, SavedListResponse, SavedToggleResponse } from '../types/ad';

// Accept either new `success` flag or legacy `status_code` as success
function isOk<T>(envelope: ApiEnvelope<T>): boolean {
  if (typeof envelope.success === 'boolean') return envelope.success;
  const code = envelope.status_code;
  return code === 200 || code === 201 || code === 204;
}

export const listSavedItems = async () => {
  const response = await api.get<SavedListResponse>('/api/saved-ads/');
  if (isOk(response) && response.data) return response.data;
  throw new Error(response.message || 'Failed to fetch saved items');
};

export const toggleSaved = async (adId: string) => {
  const response = await api.post<SavedToggleResponse>(`/api/saved-ads/${adId}/toggle/`);
  if (isOk(response) && response.data) return response.data;
  throw new Error(response.message || 'Failed to toggle saved state');
};
